import React, { Component } from "react";
import {
  IAcceptConditionsProps,
  IAcceptConditionsState,
} from "./AcceptConditions.types";
import { CheckBoxState, CheckBox } from "../FormControls/CheckBox";

const ACCEPT_CONDITIONS_ID = "ACCEPT_CONDITIONS_ID";
const ACCEPT_CONDITIONS_NAME = "acceptConditions";

/**
 * Makes sure that the conditions checkbox is marked before the user can navigate to the form page.<br>
 * The continue button is disabled if the checkbox is not marked.<br/>
 * **TODO: Move to Regbest project**
 */
export class AcceptConditions extends Component<
  IAcceptConditionsProps,
  IAcceptConditionsState
> {
  static defaultProps = {
    conditionText: "",
    formLink: "#",
    buttonText: "Vidare till beställning", //PBI 6049: Need to be able to inject this for other purposes.
  };

  constructor(props: IAcceptConditionsProps) {
    super(props);
    this.state = {
      value: false,
      aClassName: "button--disabled",
      currentLink: "#",
    };
  }

  onChange = (e: CheckBoxState) => {
    const { formLink } = this.props;
    let isSelected = e.value;
    this.setState({
      value: isSelected,
      aClassName: isSelected ? "" : "button--disabled",
      currentLink: isSelected ? formLink : "#",
    });
  };

  public render() {
    const { currentLink, aClassName, value } = this.state;
    const { conditionText, buttonText } = this.props;
    return (
      <div className="accept-conditions">
        <hr />
        <label htmlFor={ACCEPT_CONDITIONS_ID}>{conditionText}</label>
        <CheckBox
          label="Ja"
          onChange={this.onChange}
          id={ACCEPT_CONDITIONS_ID}
          fieldName={ACCEPT_CONDITIONS_NAME}
        />
        <hr />
        <div className="form-submit">
          <a
            href={currentLink}
            className={`button button--wide ${aClassName}`}
            aria-label={
              value
                ? null
                : "Vidare till beställning, du kan inte gå vidare förrän du accepterat användarvillkoren."
            }
          >
            {buttonText}
          </a>
        </div>
        <hr />
      </div>
    );
  }
}
